// 511/530 Little Collins St, Melbourne VIC 3000, Australia
export const DefaultLocation = {
  lat: -37.81617782525946,
  lng: 144.95693222849053,
};

export const LIBRARIES: ('places' | 'geometry' | 'drawing' | 'marker')[] = [
  'places',
  'geometry',
  'drawing',
  'marker',
];

export const DefaultZoom = 10;

export const DefaultMapOptions: google.maps.MapOptions = {
  fullscreenControl: false,
  streetViewControl: true,
  mapTypeControl: true,
};
